import InputField from './TextAreaField';
import { TextAreaFieldProps, TextAreaFieldValueProps } from './types';

export type { TextAreaFieldProps, TextAreaFieldValueProps };
export default InputField;
